import {createBrowserRouter, RouterProvider} from "react-router-dom";
import HomePage from "@/admin/pages/homepage/HomePage";
import React from "react";
import ProfilesManager from "@/admin/pages/profiles/ProfilesManager";
import User from "@/admin/pages/user/User";
import UserTickets from "@/admin/pages/user/tickets/UserTickets";
import AdminReports from "@/admin/pages/reports/adminPage/AdminReports";
import Redirect from "@/commons/utils/Components/Redirect";
import AdminCategories from "@/admin/pages/category/AdminCategories";
import Chats from "@/admin/pages/logs/chats/Chats";
import InfoPage from "@/admin/pages/infos/InfoPage";
import Error from "@/www/pages/error/Error";
import GroupsManager from "@/admin/pages/groups/GroupsManager";
import {environment} from "@/commons/configs/Config";
import SingleLogChatPrivate from "@/admin/pages/logs/singlechat/private/SingleLogChatPrivate";
import SingleLogChatPublic from "@/admin/pages/logs/singlechat/public/SingleLogChatPublic";
import Support from "@/admin/pages/support/Support";
import ProtectedRoute from "@/commons/ProtectedRoute";

const AdminApp: React.FC = () => {
    let path = window.location.pathname;

    if (!path.toLocaleLowerCase().includes("error")) {
        localStorage.setItem("errorName", "pageerror");
    }

    const withPermission = (
        element: React.ReactElement,
        permission: string,
        fallback = "/"
    ) => (
        <ProtectedRoute permission={permission} fallback={fallback} element={element} />
    );

    const appContent = createBrowserRouter(
        [{
            path: '/', element: <HomePage/>
        }, {
            path: '/logs/chats/:type', element: withPermission(<Chats/>, "adminpages.openpage.logs", "/")
        }, {
            path: '/logs/chat/private/:uuid', element: withPermission(<SingleLogChatPrivate/>, "adminpages.openpage.logs", "/")
        }, {
            path: '/logs/chat/public/:uuid', element: withPermission(<SingleLogChatPublic/>, "adminpages.openpage.logs", "/")
        }, {
            path: '/infos', element: withPermission(<InfoPage/>, "adminpages.openpage.infos", "/")
        }, {
            path: '/home', element: <Redirect domain={environment.production ? "www" : "wwwdev"}/>
        }, {
            path: '/profile', element: <Redirect domain={environment.production ? "www" : "wwwdev"} to={"profile"}/>
        }, {
            path: '/faq', element: <Redirect domain={environment.production ? "www" : "wwwdev"} to={"faq"}/>
        }, {
            path: '/admin', element: <Redirect to={"/"}/>
        }, {
            path: '/profiles', element: withPermission(<ProfilesManager/>, "adminpages.openpage.profiles", "/")
        }, {
            path: '/groups', element: withPermission(<GroupsManager/>, "adminpages.openpage.groups", "/")
        }, {
            path: '/reports', element: withPermission(<AdminReports/>, "adminpages.openpage.reports", "/")
        }, {
            path: '/categories', element: withPermission(<AdminCategories/>, "adminpages.openpage.categories", "/")
        }, {
            path: '/user/tickets/:id', element: <UserTickets/>
        }, {
            path: '/user/:id', element: <User/>
        }, {
            path: '/support', element: <Support/>
        }, {
            path: '/support/:file/*', element: <Support/>
        }, {
            path: '*', element: <Error errorCode={"notfound"}/>
        }]
    )

    return (
        <RouterProvider router={appContent}/>
    )
}

export default AdminApp;